var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { createOverridableComponent } from '../util/OverridableComponent';
import { useDrop } from '../hooks/useDrop';
export var DropTarget = createOverridableComponent('div', function (_a, Component, ref) {
    var onDropData = _a.onDropData, className = _a.className, props = __rest(_a, ["onDropData", "className"]);
    var _b = useDrop(onDropData), onDropEvent = _b.onDropEvent, activated = _b.activated;
    return (jsx(Component, __assign({ ref: ref }, props, { onDragEnter: onDropEvent, onDragOver: onDropEvent, onDragLeave: onDropEvent, onDrop: onDropEvent, className: className + ' ' + (activated ? 'activated' : '') })));
});
//# sourceMappingURL=DropTarget.js.map